import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory, Router, Route, IndexRoute,IndexRedirect, Link } from 'react-router';

import isEmail from 'validator/lib/isEmail';

import img from '../../images/lyrics_book.jpg';

import '../../styles/chapter2/evaluate_questions.scss';



function sendEmail(email,that){
	var http = new XMLHttpRequest();
	var url = _assets.emailRoot + "/postEmail.php";
	var params = "email="+ encodeURI(email);
	http.open("POST", url, true);
	http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	http.onreadystatechange = function() {
		if(http.readyState == 4 && http.status == 200) {
	    console.log('success', that);
	    that.props.showThankYou();
	  }
	  if(http.readyState == 4 && http.status == 406) {
	    console.warn('Ouh! Not able to save email!');
	  }
	}
	http.send(params);
}



class Evaluation_questions extends React.Component{

	constructor(props){
		super(props);

		this.state = {
			correctCount : this.getEvaluationCount(),
			inputValue : "your@email.com",
			userInputValue : "",
			inputFilled : false,
			notAnEmail : false,
			userAllCorrect : this.props.evalUserAnswers.every(function(element, index) {
		    // Do something.
		    if (!element){
		        return false;
		    }else{
		    	return true;
				} 
			})
		}

		
		//console.log('check userAllCorrect', this.state.userAllCorrect ,this.state.correctCount );
		//console.log(this.props.evalUserAnswers);

	}


	getEvaluationCount(){
		let correctCount = 0;
		this.props.evalUserAnswers.forEach(function(answer,index){
			if(answer){
				console.log('answer is correct' , answer);
				
				correctCount++;
			
			}else{
				console.log('answer is not correct' , answer);
			}
		}.bind(this));

		return correctCount;
	}

	evaluateInput(event){

		this.setState({
			inputFilled : true,
			userInputValue : event.target.value,
		});
	}

	sendEmail(event){
		event.preventDefault();
		if(this.state.inputFilled){
			
	  	if(isEmail(this.state.userInputValue)){
			console.log("isEmail");
	  		sendEmail(this.state.userInputValue, this);
	  	}else{
			console.log("isNotAnEmail");
	  		this.setState({
	  			notAnEmail : true
	  		},function(){
	  			setTimeout(()=>{
	  				this.setState({
	  					notAnEmail : false
	  				})
	  			},2000);
	  		});
	  	}
		}else{
			console.warn('please fill out form');
		}
	}

	render(){

		return (<div className="evaluation-question">
				<div className="evaluation-question">

				{/* All correct */}
					{ this.state.userAllCorrect &&
						<div className="evaluation-question-all-correct">
							<div className="evaluation-question-header">
								<h1>Yay! You got <span className="bolder">{this.state.correctCount}/5</span> answers!</h1>
								<div className="evaluation-answer-bubble-holder">
									{this.props.evalUserAnswers.map(function(answer,index){
										return (<div className={"evaluation-answer-bubble evaluation-answer-"+ answer }></div>);
									}.bind(this))}
								</div>
								<div className="evaluation-skip">
									<Link to={_assets.root +"/outro"}>Continue to outro</Link>
								</div>
							</div>
							{/*

							<div className="col-holder">
								<div className="col-left">
									<img src={img} alt="lyrics book" />
								</div>
								<div className="col-right">
									<p>Get a chance to win a handwritten lyric sheet of Cocoon!</p>
									
									<form onSubmit={(event)=>this.sendEmail(event)}>
										<p>{!this.state.notAnEmail &&
										<span >Enter your e-mail and be part of the raffle.</span>
										}
										{this.state.notAnEmail &&
										<span className="wrong-email">Please enter a valid email</span>
										}</p>
										<div className="input-holder">
											<input rel={(input) =>{this.input = input; }} type="text" placeholder={this.state.inputValue} onChange={(event)=>this.evaluateInput(event)}/> 
											{this.state.inputFilled && 
												<button>Take part</button>
											}
										</div>
										
									</form>
									
								</div>
							
							</div>*/}
						</div>
					}
					{/* All correct */}
					{ !this.state.userAllCorrect &&

						<div className="evaluation-question-not-correct">
							<div className="evaluation-question-header">
								<h1>Ouh! You only got <span className="bolder">{this.state.correctCount}/5</span> answers!</h1>
								<div className="evaluation-answer-bubble-holder">
									{this.props.evalUserAnswers.map(function(answer,index){
										return (<div className={"evaluation-answer-bubble evaluation-answer-"+ answer }></div>);
									}.bind(this))}
								</div>
							</div>
							<div className="col-holder">
								<div className="col-left">
									<img src={img} alt="lyrics book" />
								</div>
								<div className="col-right">
									<p>Try again to get the chance to win a handwritten lyric sheet of Cocoon</p>
									<button data-question="0" onClick={(event)=>this.props.goToSpecificQuestion(event)}>Try again</button>
									<div className="evaluation-skip">
										<Link to={_assets.root +"/outro"}>Skip to outro</Link>
									</div>
								</div>
							</div>
						</div>
					}
				</div>
			</div>);
	}
}

export default Evaluation_questions;


// WEBPACK FOOTER //
// ./src/scripts/chapter2/evaluation_questions.js